import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addOrUpdateInstrumentRow, deleteInstrumentRow, selectIsMarketController, selectOrderPair, selectTSUserId } from '../../redux/globalsSlice';
import {
   ADD_ROW, BUYORDERBOOK_TABLE, ConvertStatus, DELETE_ROW,
   GetInstrumentTypeName, INSTRUMENT_SELECTED, 
   JSON_KEY_BASE, JSON_KEY_CLOSE, JSON_KEY_CODE, JSON_KEY_CURRENCY, JSON_KEY_HIGH,
   JSON_KEY_INSTRUMENT_TYPE, JSON_KEY_LAST, JSON_KEY_LOW, JSON_KEY_MARKET,
   JSON_KEY_DESCRIPTION, JSON_KEY_OPEN, JSON_KEY_PREVIOUS_PRICE, 
   JSON_KEY_REFERENCE_PRICE, JSON_KEY_STATUS, 
   JSON_KEY_VALUE, JSON_KEY_VOLUME, JSON_KEY_VWAP, PUBLIC_TRADE, SELLORDERBOOK_TABLE,
   TABLE_HEADER_BASE, TABLE_HEADER_CLOSE, TABLE_HEADER_CODE, TABLE_HEADER_CURRENCY,
   TABLE_HEADER_HIGH, TABLE_HEADER_LAST, TABLE_HEADER_LOW,
   TABLE_HEADER_MARKET, TABLE_HEADER_DESCRIPTION, TABLE_HEADER_OPEN, TABLE_HEADER_PREVIOUS,
   TABLE_HEADER_REFERENCE, TABLE_HEADER_STATUS, TABLE_HEADER_TRADES, TABLE_HEADER_TYPE, TABLE_HEADER_VALUE,
   TABLE_HEADER_VOLUME, TABLE_HEADER_VWAP, UPDATE_ROW, FormatWithDecimals,
   DROPDOWN_LIST_NONE, AddItemToDropdown, ADD_MARKET, INSTRUMENT_TYPE_CURRENCY,
   ORDERS_FORM,
   TABLE_HEADER_LAST_AUCTION,
   JSON_KEY_LAST_AUCTION_PRICE,
   INSTRUMENT_TYPE_CRYPTO_CURRENCY,
   priceChangeColor,
   JSON_KEY_ISSUE_QTY,
   TABLE_HEADER_ISSUE_QTY,
   TABLE_HEADER_TRADING_RULES,
   JSON_KEY_TRADING_RULES,
   INSTRUMENT_TYPE_CRYPTO,
   parsePossiblyScaled,
   FormatForDisplay,
   JSON_KEY_NUMBER_OF_TRADES,
   instrumentCodeColor,
   statusTextColor,
   rowOpacityForStatus
} from '../../common/common';
import { DispatchTableEvent } from '../events/events';
import { Modal } from 'react-bootstrap';
import InstrumentsAdminForm from '../forms/instruments_admin_form';
import { addHoldings, addInstrument, selectTradingRules } from '../../redux/dropDownSlice';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';
import { OrderPairForm } from '../forms/order_pair_form/order_pair_form';

const FormatInstrumentRow = (data) => {
   const id = data.code;
   const price_dec = Number(data.price_dec) || 0;
   const qty_dec = Number(data.qty_dec) || 0;
   const reference_price = data.ref;
   const previous_price = data.prev;
   const open_price = data.open;
   const close_price = data.close;
   const issue_qty = data.issue;

   return {
      ...data,
      id,
      issue: issue_qty != null ? FormatWithDecimals(issue_qty, 0) : "",
      ref: reference_price != null ? FormatWithDecimals(reference_price, price_dec) : "",
      prev: previous_price != null ? FormatWithDecimals(previous_price, price_dec) : "",
      open: open_price != null ? FormatWithDecimals(open_price, price_dec) : "",
      close: close_price != null ? FormatWithDecimals(close_price, price_dec) : "",
      last: data.last != null ? FormatWithDecimals(data.last, price_dec) : "",
      high: data.high != null ? FormatWithDecimals(data.high, price_dec) : "",
      low: data.low != null ? FormatWithDecimals(data.low, price_dec) : "",
      vwap: data.vwap != null ? FormatWithDecimals(data.vwap, price_dec) : "",
      vol: data.vol != null ? FormatWithDecimals(data.vol, qty_dec) : "",
      val: data.val != null ? data.val : "",
      num_trd: data.num_trd != null ? FormatWithDecimals(data.num_trd, 0) : "",
      i_type: GetInstrumentTypeName(data.i_type),
      status: ConvertStatus(data.status),
   };
};

const Instruments3 = () => {
   const [selectedRowId, setSelectedRowId] = useState(null);
   const dispatch = useDispatch();
   const tsUserId = useSelector(selectTSUserId);
   const [showForm, setShowForm] = useState(false);
   const [showOrderPairForm, setShowOrderPairForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const [code, setCode] = useState(null);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   const orderPair = useSelector(selectOrderPair);
   const orderPairRef = useRef(orderPair);
   const [dropDownInstrumentData, setDropDownInstrumentData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   const [dropDownMarketsData, setDropDownMarketsData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   const [dropDownCurrencyData, setDropDownCurrencysData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   const [dropDownAllInstrumentsData, setDropDownAllInstrumentData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   const dropDownTradingRulesData = useSelector(selectTradingRules);

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);

   useEffect(() => {
      orderPairRef.current = orderPair;
   }, [orderPair]);

   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };
   
   const handleOrderPairCloseForm = () => {
      setShowOrderPairForm(false); 
      setSelectedRow(null);
   };
   
   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[InstrumentsTable] Row Clicked:`, rowData, ", rowData.code:", rowData.code);
      // dispatch event for orderbook update
      DispatchTableEvent(INSTRUMENT_SELECTED, BUYORDERBOOK_TABLE, rowData.code);
      DispatchTableEvent(INSTRUMENT_SELECTED, SELLORDERBOOK_TABLE, rowData.code);
      DispatchTableEvent(INSTRUMENT_SELECTED, ORDERS_FORM, rowData.code);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[InstrumentsTable] Row Double Clicked:`, rowData, ', show order pair: ', showOrderPairForm, ', orderPairRef', orderPairRef.current, ', code: ', rowData.code);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      } else if (orderPairRef.current) {
         setCode(rowData.code);
         setShowOrderPairForm(true);          
      }
   }, []);

   const columnStyling = useMemo(() => {
      const base = Object.fromEntries(
         ['last', 'open', 'high', 'low', 'vwap', 'close'].map((field) => [
            field,
            (rowData) => ({
            color: priceChangeColor(rowData[field], rowData.prev),
            }),
         ]),
      );
      base[JSON_KEY_CODE] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);
         
   // At component level, add batching refs
   const rawInstrumentStore = useRef(new Map());
   const instrumentFlushTimer = useRef(null);
   const tradeFlushTimer = useRef(null);
   const instrumentMessageCount = useRef(0);

   // FIXED handleEvents - Currency filtering and no double processing
   const handleEvents = useCallback((details, setLocalTableData) => {
      switch (details.type) {
         case ADD_ROW: {
            const id = details.data.code;
            const modifiedRow = FormatInstrumentRow(details.data);

            // CRITICAL FIX: Check if should show in table FIRST
            const shouldShowInTable = 
               (details.data.i_type !== INSTRUMENT_TYPE_CURRENCY) && 
               (details.data.i_type !== INSTRUMENT_TYPE_CRYPTO_CURRENCY);

            // ONLY store in rawInstrumentStore if should show in table
            if (shouldShowInTable) {
               instrumentMessageCount.current++;
               rawInstrumentStore.current.set(id, modifiedRow);

               // Batch flush instruments
               if (!instrumentFlushTimer.current) {
                  instrumentFlushTimer.current = setTimeout(() => {
                     // const startTime = performance.now();
                     const instruments = Array.from(rawInstrumentStore.current.values());
                     
                     // console.log(`[InstrumentsTable] Batch ADD: ${instrumentMessageCount.current} messages, ${instruments.length} rows`);
                     
                     setLocalTableData(instruments);
                     
                     // console.log(`[InstrumentsTable] Batch ADD complete in ${(performance.now() - startTime).toFixed(0)}ms`);
                     
                     instrumentMessageCount.current = 0;
                     instrumentFlushTimer.current = null;
                  }, 1000);
               }
            }

            // Always update Redux (for all instruments including currencies)
            dispatch(addOrUpdateInstrumentRow(modifiedRow));

            if (details.data.i_type !== INSTRUMENT_TYPE_CRYPTO) {
               dispatch(addHoldings({ id: modifiedRow.code, name: modifiedRow.code }));
            }

            AddItemToDropdown(setDropDownAllInstrumentData, { id: details.data.code, name: details.data.code });

            if (shouldShowInTable) {
               AddItemToDropdown(setDropDownInstrumentData, { id: details.data.code, name: details.data.code });
               dispatch(addInstrument({ id: modifiedRow.code, name: modifiedRow.code }));
            } else {
               AddItemToDropdown(setDropDownCurrencysData, { id: details.data.code, name: details.data.code });
            }

            break;
         }

         case UPDATE_ROW: {
            const id = details.data.code;
            const modifiedRow = FormatInstrumentRow(details.data);

            const shouldShowInTable = 
               (details.data.i_type !== INSTRUMENT_TYPE_CURRENCY) && 
               (details.data.i_type !== INSTRUMENT_TYPE_CRYPTO_CURRENCY);

            if (shouldShowInTable) {
               instrumentMessageCount.current++;
               rawInstrumentStore.current.set(id, modifiedRow);

               if (!instrumentFlushTimer.current) {
                  instrumentFlushTimer.current = setTimeout(() => {
                     // const startTime = performance.now();
                     
                     setLocalTableData(prev => {
                        const updated = new Map(prev.map(r => [r.id, r]));
                        
                        rawInstrumentStore.current.forEach((row, id) => {
                           // Just use the new row directly!
                           updated.set(id, row);
                        });
                        
                        // console.log(`[InstrumentsTable] Batch UPDATE complete in ${(performance.now() - startTime).toFixed(0)}ms`);
                        return Array.from(updated.values());
                     });
                     
                     instrumentMessageCount.current = 0;
                     instrumentFlushTimer.current = null;
                  }, 500);
               }
            }

            dispatch(addOrUpdateInstrumentRow(modifiedRow));
            break;
         }

         case DELETE_ROW: {
            const modifiedRow = FormatInstrumentRow(details.data);
            
            rawInstrumentStore.current.delete(modifiedRow.code);
            
            const shouldShowInTable = 
               (details.data.i_type !== INSTRUMENT_TYPE_CURRENCY) && 
               (details.data.i_type !== INSTRUMENT_TYPE_CRYPTO_CURRENCY);
               
            if (shouldShowInTable) {
               setLocalTableData(prev => prev.filter(row => row.code !== modifiedRow.code));
            }

            dispatch(deleteInstrumentRow(modifiedRow.code));
            break;
         }

         case INSTRUMENT_SELECTED: { 
            if (details) {
               const selectedRowCode = details.data;
               setSelectedRowId(selectedRowCode);
            }
            break;
         }
         
         case PUBLIC_TRADE: {
            if (details.data.stats === false) break;

            // CRITICAL: Clear any pending instrument batch to avoid overwriting
            if (instrumentFlushTimer.current) {
               clearTimeout(instrumentFlushTimer.current);
               instrumentFlushTimer.current = null;
               console.log('[InstrumentsTable] Cleared pending instrument batch for PUBLIC_TRADE');
            }

            const instrumentCode = details.data.instr;
            
            // ✅ FIX: Store the updated row to dispatch AFTER state update
            let rowToDispatch = null;

            setLocalTableData(prevData => {
               const instrumentMap = new Map(prevData.map(row => [row.id, row]));
               const row = instrumentMap.get(instrumentCode);
               
               if (!row) {
                  return prevData;
               }

               // CRITICAL FIX: Get decimals from the ROW, not from details.data!
               const price_dec = row.price_dec || 0;
               const qty_dec = row.qty_dec || 0;

               // Parse previous values
               const prevVolume = row.vol ? parsePossiblyScaled(row.vol, qty_dec) : 0;
               const prevValue = row.val ? parsePossiblyScaled(row.val, price_dec) : 0;
               const prevTrades = row.num_trd ? Number(String(row.num_trd).replace(/,/g, "")) : 0;
               const prevHigh = row.high ? parsePossiblyScaled(row.high, price_dec) : null;
               const prevLow = row.low ? parsePossiblyScaled(row.low, price_dec) : null;
               
               // console.log('prevVolume:', row.vol, ', prevValue:', row.val, ', prevTrades:', row.num_trd, ', prevHigh:', row.high, ', prevLow:', row.low);
               // Parse incoming trade
               const incomingPrice = parsePossiblyScaled(details.data.price, price_dec);
               const incomingQty = parsePossiblyScaled(details.data.qty, qty_dec);

               // console.log('data.price:', details.data.price, ', data.qty:', details.data.qty, ', price dec:', price_dec, 
               //    ', qty_dec:', qty_dec, ', incomingprice: ', incomingPrice, ', incomineqty: ', incomingQty);
               // Calculate new values
               const newVolume = prevVolume + incomingQty;
               const newValue = prevValue + (incomingPrice * incomingQty);
               const newVWAP = newVolume > 0 ? newValue / newVolume : 0;
               
               const isNewHigh = prevHigh === null || incomingPrice > prevHigh;
               const isNewLow = prevLow === null || incomingPrice < prevLow;

               // console.log('newVolume:', newVolume, ', newValue:', newValue, ', newVWAP:', newVWAP.toFixed(price_dec), ', isNewHigh:', isNewHigh, ', isNewLow:', isNewLow);
               // Create updated row with NEW OBJECT REFERENCE
               const updatedRow = {
                  ...row,
                  last: FormatForDisplay(incomingPrice, price_dec),
                  vol: FormatForDisplay(newVolume, qty_dec),
                  val: FormatForDisplay(newValue, price_dec),
                  num_trd: FormatForDisplay(prevTrades + 1, 0),
                  vwap: FormatForDisplay(newVWAP, price_dec),
                  high: isNewHigh ? FormatForDisplay(incomingPrice, price_dec) : (row.high || ""),
                  low: isNewLow ? FormatForDisplay(incomingPrice, price_dec) : (row.low || "")
               };
               
               // CRITICAL: Update rawInstrumentStore so future batches use this data
               rawInstrumentStore.current.set(instrumentCode, updatedRow);
               
               // ✅ FIX: Store for dispatch after state update
               rowToDispatch = updatedRow;
               
               // CRITICAL: Create NEW array with NEW object to force React re-render
               instrumentMap.set(instrumentCode, updatedRow);
               const newArray = Array.from(instrumentMap.values());
               
               return newArray;
            });

            // ✅ FIX: Dispatch AFTER setLocalTableData completes
            if (rowToDispatch) {
               dispatch(addOrUpdateInstrumentRow(rowToDispatch));
            }

            break;
         }

         case ADD_MARKET:
            AddItemToDropdown(setDropDownMarketsData, { id: details.data.code, name: details.data.code });
            break;
      
         default:
            break;
      }
   }, [dispatch]);

   // Add cleanup on unmount
   useEffect(() => {
      return () => {
         // eslint-disable-next-line react-hooks/exhaustive-deps
         if (tradeFlushTimer.current) {
            clearTimeout(tradeFlushTimer.current);
            tradeFlushTimer.current = null;
         }
         // eslint-disable-next-line react-hooks/exhaustive-deps
         if (instrumentFlushTimer.current) {
            clearTimeout(instrumentFlushTimer.current);
            instrumentFlushTimer.current = null;
         }
      };
   }, []);

   const columns = useMemo(() => {
      const baseColumns = [
         { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_CODE },
         { Header: TABLE_HEADER_DESCRIPTION, accessor: JSON_KEY_DESCRIPTION },
         { Header: TABLE_HEADER_TYPE, accessor: JSON_KEY_INSTRUMENT_TYPE },
         { Header: TABLE_HEADER_MARKET, accessor: JSON_KEY_MARKET },
         { Header: TABLE_HEADER_BASE, accessor: JSON_KEY_BASE },
         { Header: TABLE_HEADER_CURRENCY, accessor: JSON_KEY_CURRENCY },
         { Header: TABLE_HEADER_ISSUE_QTY, accessor: JSON_KEY_ISSUE_QTY },
         { Header: TABLE_HEADER_LAST, accessor: JSON_KEY_LAST },
         { Header: TABLE_HEADER_PREVIOUS, accessor: JSON_KEY_PREVIOUS_PRICE },
         { Header: TABLE_HEADER_REFERENCE, accessor: JSON_KEY_REFERENCE_PRICE },
         { Header: TABLE_HEADER_STATUS, accessor: JSON_KEY_STATUS },
         { Header: TABLE_HEADER_TRADES, accessor: JSON_KEY_NUMBER_OF_TRADES },
         { Header: TABLE_HEADER_VOLUME, accessor: JSON_KEY_VOLUME },
         { Header: TABLE_HEADER_VALUE, accessor: JSON_KEY_VALUE },
         { Header: TABLE_HEADER_HIGH, accessor: JSON_KEY_HIGH },
         { Header: TABLE_HEADER_LOW, accessor: JSON_KEY_LOW },
         { Header: TABLE_HEADER_VWAP, accessor: JSON_KEY_VWAP },
         { Header: TABLE_HEADER_OPEN, accessor: JSON_KEY_OPEN },
         { Header: TABLE_HEADER_CLOSE, accessor: JSON_KEY_CLOSE },
         { Header: TABLE_HEADER_LAST_AUCTION, accessor: JSON_KEY_LAST_AUCTION_PRICE },
      ];

      if (isMarketController) {
         baseColumns.push({Header: TABLE_HEADER_TRADING_RULES, accessor: JSON_KEY_TRADING_RULES,});
      }

      return baseColumns;
   }, [isMarketController]);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="InstrumentsTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            selectedRowId={selectedRowId}
            setSelectedRowId={setSelectedRowId}
            enableSearch={true}
            columnStyling={columnStyling}
            rowStyling={(row) => ({ opacity: rowOpacityForStatus(row.status) })}
         />
         <Modal show={showForm} onHide={handleCloseForm}>
            <InstrumentsAdminForm rowData={selectedRow} onClose={handleCloseForm} 
            allInstrumentsOptions={dropDownAllInstrumentsData} 
            instrumentOptions={dropDownInstrumentData} 
            currencyOptions={dropDownCurrencyData} 
            marketOptions={dropDownMarketsData}
            tradingRulesOptions={dropDownTradingRulesData}/>
         </Modal>

         <Modal show={showOrderPairForm} onHide={handleOrderPairCloseForm}>
            {<OrderPairForm instrument_code={code} onClose={handleOrderPairCloseForm}/>}
         </Modal>
      </>
   );
};

export default Instruments3;